import React, { Component } from 'react';

import { ButtonIcon } from 'components/button';
import { Card } from 'components/card';
import { I18n } from 'components/translate';
import { formatBytes } from 'helpers/File';
import isEmpty from 'lodash/isEmpty';
import mime from 'mime-types';
import PropTypes from 'prop-types';

import { ASYNC_IMAGE_MAX_TRIALS, ASYNC_IMAGE_INTERVAL } from '../constants';
import FileService from '../FileService';

export default class FileCard extends Component {
  state = {
    fileSignedUrl: this.props.fileSignedUrl
  };

  static propTypes = {
    'id': PropTypes.string,
    'fileId': PropTypes.string,
    'name': PropTypes.string,
    'size': PropTypes.number,
    'removeFile': PropTypes.func,
    'type': PropTypes.string,
    'contentType': PropTypes.string,
    'fileSignedUrl': PropTypes.string,
    'enableVisualize': PropTypes.bool,
    'origin': PropTypes.string,
    'status': PropTypes.string,
    'entityType': PropTypes.string,
    'playerMedia': PropTypes.object,
    'data-test': PropTypes.string
  };

  static defaultProps = {
    enableVisualize: true
  };

  interval = null;

  get id() {
    return this.props.id || this.props.fileId;
  }

  get formattedSize() {
    const { size } = this.props;

    return formatBytes(size);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async setPrivateFileLink(fileId) {
    this.isUrlFilled = true;

    let trials = 0;

    this.interval = setInterval(async () => {
      if (trials < ASYNC_IMAGE_MAX_TRIALS) {
        try {
          const { fileSignedUrl } = await FileService.fetchPrivateFileLink(
            fileId
          );

          clearInterval(this.interval);
          this.setState({ fileSignedUrl });
        } catch (e) {
          trials++;
        }
      } else {
        clearInterval(this.interval);
      }
    }, ASYNC_IMAGE_INTERVAL);
  }

  isUrlEmpty(fileSignedUrl) {
    return isEmpty(fileSignedUrl) && !this.isUrlFilled;
  }

  componentDidMount() {
    this.onUpdateURL();
  }

  componentDidUpdate() {
    this.onUpdateURL();
  }

  onUpdateURL() {
    const { origin, id } = this.props;
    const { fileSignedUrl } = this.state;

    if (this.props.enableVisualize) {
      const isUrlEmpty = this.isUrlEmpty(fileSignedUrl);
      const isUploadFinished = FileService.isAttachmentFinished(this.props);

      if (isUploadFinished && isUrlEmpty) {
        this.setPrivateFileLink(id);
      } else if (origin && origin !== 'UPLOAD' && isUrlEmpty) {
        this.setState({ fileSignedUrl: this.props.fileSignedUrl });
      }
    }
  }

  openFile = () => {
    const { entityType } = this.props;

    FileService.openFile(this.id, entityType);
  };

  removeFile = () => {
    const { removeFile } = this.props;

    removeFile && removeFile(this.id);
  };

  render() {
    const {
      type,
      contentType,
      name,
      enableVisualize,
      'data-test': dataTest
    } = this.props;
    const fileType =
      mime.extension(type || contentType) || name.split('.').pop();

    return (
      <Card className="file__card" data-test={dataTest}>
        <div className="card__header">
          <span className="file__type">{fileType}</span>
          <span>{this.formattedSize}</span>
        </div>
        <div className="card__body _truncate-3">{name}</div>
        <div className="card__footer">
          {enableVisualize && (
            <ButtonIcon
              className="card__button"
              transparent
              type="button"
              variation="secondary"
              icon="visualize"
              onClick={this.openFile}
            >
              <I18n label="general.visualize" />
            </ButtonIcon>
          )}

          <ButtonIcon
            className="card__button"
            transparent
            type="button"
            variation="secondary"
            icon="delete"
            onClick={this.removeFile}
          >
            <I18n label="general.remove" />
          </ButtonIcon>
        </div>
      </Card>
    );
  }
}
